export function removeCSSClass(ele, cls) {
  const reg = new RegExp("(\\s|^)" + cls + "(\\s|$)");
  ele.className = ele.className.replace(reg, " ");
}

export function addCSSClass(ele, cls) {
  ele.classList.add(cls);
}

export const toAbsoluteUrl = (pathname) => {
  // Handle empty pathname
  if (!pathname) return import.meta.env.BASE_URL;
  
  // Remove leading slash from pathname if it exists to avoid double slashes
  const cleanPath = pathname.startsWith("/") ? pathname.slice(1) : pathname;
  
  // Ensure BASE_URL ends with slash for proper concatenation
  const baseUrl = import.meta.env.BASE_URL.endsWith("/") 
    ? import.meta.env.BASE_URL 
    : import.meta.env.BASE_URL + "/";
    
  return baseUrl + cleanPath;
};
